
import { faker } from "@faker-js/faker";

// Indian Names
const indianFirstNames = [
  "Aarav",
  "Vivaan",
  "Aditya",
  "Vihaan",
  "Arjun",
  "Sai",
  "Reyansh",
  "Ayaan",
  "Krishna",
  "Ishaan",
  "Shaurya",
  "Atharv",
  "Advik",
  "Pranav",
  "Vedant",
  "Abhimanyu",
  "Siddharth",
  "Samarth",
  "Arnav",
  "Karan",
  "Priya",
  "Ananya",
  "Fatima",
  "Aadhya",
  "Kavya",
  "Anika",
  "Diya",
  "Pihu",
  "Inaya",
  "Riya",
  "Avni",
  "Myra",
  "Sara",
  "Jhanvi",
  "Pari",
  "Anvi",
  "Khushi",
  "Mira",
  "Saanvi",
  "Aishwarya",
];

const indianLastNames = [
  "Sharma",
  "Verma",
  "Singh",
  "Kumar",
  "Gupta",
  "Agarwal",
  "Mishra",
  "Jain",
  "Bansal",
  "Arora",
  "Malhotra",
  "Chopra",
  "Kapoor",
  "Mehta",
  "Shah",
  "Patel",
  "Reddy",
  "Nair",
  "Iyer",
  "Menon",
  "Rao",
  "Krishnan",
  "Pillai",
  "Srinivasan",
  "Bhat",
  "Kulkarni",
  "Desai",
  "Joshi",
  "Pandey",
  "Tiwari",
];

// Name Generator
function generateIndianName() {
  const firstName =
    indianFirstNames[Math.floor(Math.random() * indianFirstNames.length)];
  const lastName =
    indianLastNames[Math.floor(Math.random() * indianLastNames.length)];
  return `${firstName} ${lastName}`;
}

// Employee Generator
function generateEmployees() {
  const employees = [];

  // RA Manager
  employees.push({
    id: 1,
    name: generateIndianName(),
    role: "RA Manager",
    reportingManager: null,
    email: `employee1@company.com`,
  });

  employees.push({
    id: 2,
    name: generateIndianName(),
    role: "RA Manager",
    reportingManager: null,
    email: `employee1@company.com`,
  });

  const teamLeads = [];

  // 5 RA Team Leads
  for (let i = 0; i < 5; i++) {
    const id = employees.length + 1;
    const teamLead = {
      id,
      name: generateIndianName(),
      role: "RA Team Lead",
      reportingManager: 1,
      email: `employee${id}@company.com`,
    };
    employees.push(teamLead);
    teamLeads.push(id);
  }

  for (let i = 0; i < 5; i++) {
    const id = employees.length + 1;
    const teamLead = {
      id,
      name: generateIndianName(),
      role: "RA Team Lead",
      reportingManager: 2,
      email: `employee${id}@company.com`,
    };
    employees.push(teamLead);
    teamLeads.push(id);
  }

  // Remaining RAs
  const total = 34; // total 34 employees including manager and leads
  while (employees.length < total) {
    const id = employees.length + 1;
    const assignedTL = teamLeads[Math.floor(Math.random() * teamLeads.length)];
    employees.push({
      id,
      name: generateIndianName(),
      role: "RA",
      reportingManager: assignedTL,
      email: `employee${id}@company.com`,
    });
  }

  return employees;
}

// Date Range Generator
function generateDateRange() {
  const startDate = new Date("2023-07-15");
  const endDate = new Date();
  const dates = [];

  const current = new Date(startDate);
  while (current <= endDate) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

// Check Weekend
function isWeekend(date) {
  const day = date.getDay(); // 0 (Sun) to 6 (Sat)
  return day === 0 || day === 6;
}

// Leave probability (6%)
function isLeave() {
  return Math.random() < 0.06;
}

// Productivity Value
function generateProductivityValue(date, onLeave) {
  if (onLeave || isWeekend(date)) return 0;
  return Math.floor(Math.random() * 14) + 2; // 2–15
}

// Main Generator
function generateEmployeeProductivityData() {
  const employees = generateEmployees();
  const dates = generateDateRange();
  const productivityData = [];

  employees.forEach((employee) => {
    dates.forEach((date) => {
      const weekend = isWeekend(date);
      const onLeave = !weekend && isLeave();
      const productivityValue = generateProductivityValue(date, onLeave);

      productivityData.push({
        employeeId: employee.id,
        employeeName: employee.name,
        role: employee.role,
        reportingManager: employee.reportingManager,
        date: date.toISOString().split("T")[0],
        dayOfWeek: date.toLocaleDateString("en-US", { weekday: "long" }),
        productivityValue,
        isOnLeave: onLeave ? 1 : 0,
        isWeekend: weekend ? 1 : 0,
      });
    });
  });

  return {
    employees,
    productivityData,
    summary: {
      totalEmployees: employees.length,
      totalRecords: productivityData.length,
      dateRange: {
        start: dates[0].toISOString().split("T")[0],
        end: dates[dates.length - 1].toISOString().split("T")[0],
      },
      roles: {
        "RA Manager": employees.filter((e) => e.role === "RA Manager").length,
        "RA Team Lead": employees.filter((e) => e.role === "RA Team Lead")
          .length,
        RA: employees.filter((e) => e.role === "RA").length,
      },
    },
  };
}

const data = generateEmployeeProductivityData();
export default data;
